<template>
  <v-layout
    class="pa-4"
    row
    wrap
    justify-center
  >
    <v-flex>
      <div class="display-1 grey--text text--darken-1">
        Forgot Password
      </div>
      <div v-if="requestSuccess">
        <div class="subheading my-4">
          Password reset instructions has been sent to your registered email. Please check your
          inbox.
        </div>
        <v-btn
          color="primary"
          to="/login"
        >
          Login
        </v-btn>
      </div>
      <v-form
        v-else
        ref="form"
        class="pa-3"
        @submit.prevent="submit"
      >
        <v-text-field
          v-model="email"
          :rules="validationRules.email"
          name="email"
          label="Registered Email"
          type="email"
          required
        />
        <v-btn
          id="resetButton"
          :loading="loading"
          color="primary"
          type="submit"
        >
          Reset
        </v-btn>
      </v-form>
    </v-flex>
    <v-snackbar
      v-model="snackbar"
      :timeout="0"
      :color="snackbarColor"
      absolute
      multi-line
      bottom
    >
      {{ snackbarMessage }}
      <v-btn
        flat
        @click.native="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import validationRules from '@/mixins/validation-rules';
import { functions } from '@/firebase';

export default {
  name: 'ForgotPassword',
  mixins: [validationRules],
  data() {
    return {
      email: null,
      loading: false,
      snackbar: false,
      snackbarColor: 'primary',
      snackbarMessage: '',
      requestSuccess: false
    };
  },
  methods: {
    submit() {
      const { form } = this.$refs;
      if (!form.validate()) return;
      this.loading = true;
      const forgotPassword = functions.httpsCallable('forgotPassword');
      forgotPassword({
        email: this.email
      })
        .then(result => {
          const { status } = result.data;
          if (status === 'SUCCESS') {
            this.requestSuccess = true;
          } else if (status === 'ERROR') {
            this.snackbarColor = 'error';
            this.snackbarMessage = result.data.error.message;
            this.snackbar = true;
          }
          this.loading = false;
        })
        .catch(error => {
          this.snackbarColor = 'error';
          this.snackbarMessage = error.message;
          this.snackbar = true;
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
#resetButton {
  width: 210px;
}
</style>
